import z from 'zod';

export const postPackingSlips = {
  body: z.object({
    name: z.string().nonempty({ error: 'Packing slip name is required' }),
    project_location: z.string().nonempty({
      error: 'Project location is required',
    }),
  }),
  response: z.object({
    id: z.number(),
    name: z.string(),
    project_location: z.string(),
    created_at: z.date(),
  }),
  params: z.object({
    project_id: z.coerce.number(),
  }),
  query: z.never(),
};
const postPackingSlipsSchema = z.object(postPackingSlips);
export type PostPackingSlips = z.infer<typeof postPackingSlipsSchema>;

const getPackingSlips = {
  body: z.never(),
  response: z.array(
    z.object({
      id: z.number(),
      name: z.string(),
      project_location: z.string(),
      created_at: z.date(),
    }),
  ),
  params: z.object({
    project_id: z.coerce.number(),
  }),
  query: z.never(),
};
const getPackingSlipsSchema = z.object(getPackingSlips);
export type GetPackingSlips = z.infer<typeof getPackingSlipsSchema>;

const getPackingSlipEligibleFrames = {
  body: z.never(),
  response: z.array(
    z.object({
      frame_id: z.number(),
      frame_name: z.string(),
      remaining_quantity: z.number(),
    }),
  ),
  params: z.object({
    project_id: z.coerce.number(),
  }),
  query: z.never(),
};
const getPackingSlipEligibleFramesSchema = z.object(
  getPackingSlipEligibleFrames,
);
export type GetPackingSlipEligibleFrames = z.infer<
  typeof getPackingSlipEligibleFramesSchema
>;

const postPackingSlipFrames = {
  body: z.array(
    z.object({
      frame_id: z.coerce.number(),
      quantity: z.coerce.number(),
    }),
  ),
  response: z.object({
    id: z.number(),
    name: z.string(),
    project_id: z.number(),
    project_name: z.string(),
    project_location: z.string(),
    release_numbers: z.array(z.string()),
    items: z.array(
      z.object({
        id: z.number(),
        release_number: z.string(),
        frame_id: z.number(),
        frame_name: z.string(),
        quantity: z.number(),
      }),
    ),
  }),
  params: z.object({
    packing_slip_id: z.coerce.number(),
  }),
  query: z.never(),
};
const postPackingSlipFramesSchema = z.object(postPackingSlipFrames);
export type PostPackingSlipFrames = z.infer<typeof postPackingSlipFramesSchema>;

export const getPackingSlipFrames = {
  body: z.never(),
  response: z.object({
    id: z.number(),
    name: z.string(),
    project_id: z.number(),
    project_name: z.string(),
    project_location: z.string(),
    release_numbers: z.array(z.string()),
    items: z.array(
      z.object({
        id: z.number(),
        release_number: z.string(),
        frame_id: z.number(),
        frame_name: z.string(),
        quantity: z.number(),
        allowed_to_delete: z.number(),
      }),
    ),
  }),
  params: z.object({
    packing_slip_id: z.coerce.number(),
  }),
  query: z.never(),
};
const getPackingSlipFramesSchema = z.object(getPackingSlipFrames);
export type GetPackingSlipFrames = z.infer<typeof getPackingSlipFramesSchema>;

const deletePackingSlipFrames = {
  body: z.array(
    z.object({
      item_id: z.coerce.number().min(1, { error: 'Item id is required' }),
      quantity: z.coerce.number().min(1, { error: 'Quantity is required' }),
    }),
  ),
  response: z.never(),
  params: z.object({
    packing_slip_id: z.coerce.number(),
  }),
  query: z.never(),
};
const deletePackingSlipFramesSchema = z.object(deletePackingSlipFrames);
export type DeletePackingSlipFrames = z.infer<
  typeof deletePackingSlipFramesSchema
>;
